import { styled as t } from "styled-components";
import { CaptionLight as i, SmallLight as n } from "../../../../styles/typography/index.js";
import { MediaQuery as e } from "../../../../styles/variables.js";
const r = t.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 0;
`, l = t.div`
  display: flex;
  align-items: center;
  column-gap: 16px;

  @media ${e.SCREEN_SM} {
    &[data-reacted='true'] {
      column-gap: 32px;
    }
  }
`, s = t.button`
  background: none;
  ${i}

  display: flex;
  align-items: center;
  gap: 4px;

  i {
    font-size: 16px;
  }

  @media ${e.SCREEN_MD_UP} {
    ${n}
  }
`;
export {
  l as ActionsButtonsWrapper,
  r as Container,
  s as ReplyButton
};
